import React, { useState } from 'react';
import StatusReport from './StatusReport';
import AverageResolutionTime from './AverageResolutionTime';
import EmployeePerformance from './EmployeePerformance';
import ResolutionDistributionTime from './ResolutionDistributionTime';
import './TicketingReportPage.css'; 
import OverviewTicket from './OverviewTicket';

const TicketingReportPage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const colors = {
    primary: '#003366',
    secondary: '#7C3AED',
    accent: '#10B981',
    danger: '#EF4444',
    warning: '#F59E0B',
    info: '#3B82F6',
    light: '#F3F4F6',
    dark: '#1F2937',
    background: '#F9FAFB',
    card: '#FFFFFF',
    text: '#374151',
    textSecondary: '#6B7280',
    border: '#E5E7EB'
  };

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'avg-time', label: 'Avg Resolution Time' },
    { id: 'status', label: 'Status' },
    // { id: 'employee', label: 'Employee Performance' },
    // { id: 'distribution', label: 'Resolution Distribution' }
  ];

  return (
    <div className="enrollment-container">
      <div className="ticketing-tabs-header" style={{ backgroundColor: colors.background, border: `1px solid ${colors.border}` }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`ticketing-tab-button ${activeTab === tab.id ? 'ticketing-active' : ''}`}
            style={{
              backgroundColor: activeTab === tab.id ? colors.card : 'transparent',
              color: activeTab === tab.id ? colors.primary : colors.textSecondary,
              boxShadow: activeTab === tab.id ? `0 1px 3px ${colors.border}` : 'none'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
  
      {activeTab === 'overview' && <StatusReport colors={colors} />}
      {activeTab === 'avg-time' && <AverageResolutionTime colors={colors} />}
      {activeTab === 'status' && <OverviewTicket colors={colors} />}
      {/* {activeTab === 'distribution' && <ResolutionDistributionTime colors={colors} />}
      {activeTab === 'employee' && <EmployeePerformance colors={colors} />} */}
    </div>
  );
  
};

export default TicketingReportPage;
